// @ts-nocheck
'use client'
import { useRef } from 'react'
import { ArrowLeft, ArrowRight } from 'lucide-react'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import '@splidejs/react-splide/css/core'
import { ProductCard } from '@/components/molecules/ProductCard'
import './styles.scss'

interface Product {
  id: string
  name: string
  href: string
  image: string | null
  description: string
  width: number
  height: number
  alternativeText: string | null
  new?: boolean
}

interface ProductSliderProps {
  products: Product[]
  className?: string
  splideClassName?: string
  ariaLabel?: string
  emptyMessage?: string
}

export const ProductSlider = ({
  products,
  className = '',
  splideClassName = '',
  ariaLabel = 'product-slider',
  emptyMessage = 'Nenhum produto disponível no momento.',
}: ProductSliderProps) => {
  const splideRef = useRef<{ splide?: { go: (direction: string) => void } }>(
    null,
  )

  const handlePrevClick = () => {
    if (splideRef.current?.splide) {
      splideRef.current.splide.go('<')
    }
  }

  const handleNextClick = () => {
    if (splideRef.current?.splide) {
      splideRef.current.splide.go('>')
    }
  }

  if (products.length === 0) {
    return <p>{emptyMessage}</p>
  }

  return (
    <div className={`product-slider-container ${className}`}>
      <button
        className="splide-arrow splide-arrow--prev desktop-only"
        aria-label="Previous"
        onClick={handlePrevClick}
      >
        <ArrowLeft size={24} />
      </button>
      <Splide
        ref={splideRef}
        className={splideClassName}
        aria-label={ariaLabel}
        options={{
          type: 'loop',
          perPage: 4,
          perMove: 1,
          gap: '1rem',
          pagination: false,
          arrows: false,
          autoWidth: false,
          padding: '0.5rem',
          breakpoints: {
            1024: {
              perPage: 4,
            },
            768: {
              perPage: 2,
            },
            640: {
              perPage: 1,
              fixedWidth: '80vw',
              focus: 'center',
              trimSpace: false,
            },
          },
        }}
      >
        {products.map((product) => (
          <SplideSlide key={product.id}>
            <ProductCard product={product} />
          </SplideSlide>
        ))}
      </Splide>
      <button
        className="splide-arrow splide-arrow--next desktop-only"
        aria-label="Next"
        onClick={handleNextClick}
      >
        <ArrowRight size={24} />
      </button>
    </div>
  )
}
